export default "__VITE_ASSET__DBNAwtBi__"